"use strict";

(function () {
  const POPUP_SESSION_KEY = "poelle:gift-popup-shown";

  function getCampaignSettings() {
    const campaign =
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.giftCampaign) ||
      {};

    return {
      enabled: Boolean(campaign.enabled),
      popupEnabled: Boolean(campaign.popupEnabled),
      popupAutoOpenOnce: Boolean(campaign.popupAutoOpenOnce),
    };
  }

  function getPageType() {
    return (
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.pageType) ||
      ""
    );
  }

  function hasGiftTriggerOnPage() {
    return document.querySelector('[data-modal="modal-gift"].button-modal') !== null;
  }

  function tryAutoOpenGiftPopup() {
    const campaign = getCampaignSettings();

    if (
      !campaign.enabled ||
      !campaign.popupEnabled ||
      !campaign.popupAutoOpenOnce ||
      getPageType() !== "product"
    ) {
      return;
    }

    const modal = document.getElementById("modal-gift");

    if (!modal || !hasGiftTriggerOnPage()) {
      return;
    }

    try {
      if (sessionStorage.getItem(POPUP_SESSION_KEY) === "1") {
        return;
      }

      sessionStorage.setItem(POPUP_SESSION_KEY, "1");
    } catch (error) {
      return;
    }

    window.setTimeout(() => {
      if (window.Modals && typeof window.Modals.openModalBySelector === "function") {
        window.Modals.openModalBySelector("#modal-gift");
      } else {
        modal.classList.add("open");
      }
    }, 220);
  }

  document.addEventListener("DOMContentLoaded", () => {
    tryAutoOpenGiftPopup();
  });
})();
